module.exports = __webpack_public_path__ + "static/media/07.7e86f400.jpg";